import { Component, OnInit } from '@angular/core';
import { ModuleService } from '../../../services/modules.service';

@Component({
  selector: 'app-thumb-learn-about-io',
  templateUrl: './thumb-learn-about-io.component.html',
  styleUrls: ['./thumb-learn-about-io.component.scss', './thumb-learn-about-io.component.medium.scss']
})
export class ThumbnailLearnAboutIoComponent implements OnInit {

  constructor(private moduleService: ModuleService) { }

  ngOnInit() {
    //why is this empty?
  }

  get isAboutIoAvailable() {
    return this.moduleService.isAboutIoAvailable();
  }
}
